import { useCallback, useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { useUserCreationContext } from '@bingads-webui-campaign-react/pmax-lite-data';

export const useCampaignCreationMethodRepository = () => {
  const serverContext = useContext(ServerContext);
  const { CurrentAccount } = serverContext;
  const { isCreatingUser, createUser, createUserPromise } = useUserCreationContext();

  const save = useCallback(() => {
    if (!isCreatingUser && !CurrentAccount) {
      return createUser();
    }

    return createUserPromise;
  }, [CurrentAccount, createUser, createUserPromise, isCreatingUser]);

  return {
    save,
  };
};
